import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WidgetsModule } from 'ngx-widgets';
import { LabelService } from './../../services/label.service';
import { SelectDropdownModule } from './../../widgets/select-dropdown/select-dropdown.module';
import { LabelSelectorComponent } from './label-selector.component';



export class LabelSelectorModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    WidgetsModule,
    CommonModule,
    SelectDropdownModule
  ],
  declarations: [
    LabelSelectorComponent
  ],
  exports: [
    LabelSelectorComponent
  ],
  providers: [
    LabelService
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
